import { render, staticRenderFns } from "./add-partner.vue?vue&type=template&id=b727bcf0&scoped=true&"
import script from "./add-partner.vue?vue&type=script&lang=js&"
export * from "./add-partner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b727bcf0",
  null
  
)

export default component.exports